import React from 'react';
import {IndexLink, Link} from 'react-router';
import * as commonApi from '../../../api/common-api';

import Loading from 'react-loading';
import axios from 'axios';

var querystring = require('querystring');
import Feed from './Feed';


class FeedPopup extends React.Component {
    constructor(props) {
        super(props);

    }

    componentDidMount() {

    }

    componentWillReceiveProps(nextProps) {

    }

    handleBack(e) {
        this.props.onClose();
    }

    onNameChange(e) {
        this.setState({name: e.target.value});
    }


    render() {
        return (
            <div className="feedpopup_wrapper">
                <div className="content">
                    <div className="feed_content_w">
                        <Feed user={this.props.user} isPopup={true} handleFeedCallback={this.props.handleFeedCallback} courseId={this.props.courseId} feed={this.props.feed}/>
                    </div>
                    <div className="img_content">
                        <img src={this.props.feed.imgUrl}/>
                    </div>

                </div>
                <a onClick={this.handleBack.bind(this)} className="btn_remove"><img src="static/img/appimg/icon_close_x.png"/></a>
            </div>
        )
    }
}

export default FeedPopup;


/** WEBPACK FOOTER **
 ** ./src/client/app/appcomponents/commons/course/FeedPopup.js
 **/